import { render, staticRenderFns } from "./billTypeRadioGroup.vue?vue&type=template&id=0b224fee&"
import script from "./billTypeRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./billTypeRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports